import { render, staticRenderFns } from "./rego-customer-email-confirm.vue?vue&type=template&id=c58a5cd0&scoped=true&"
import script from "./rego-customer-email-confirm.vue?vue&type=script&lang=js&"
export * from "./rego-customer-email-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58a5cd0",
  null
  
)

export default component.exports